import Link from "next/link";

import { MdOutlineLocationOn } from "react-icons/md";
import { RiCalendarEventLine, RiUserLine, RiVideoLine } from "react-icons/ri";

import { If } from "~/components/v3/Conditional";
import { cn } from "~/utils/fontsConfig";

import { Fragment } from "react";
import { EventImage } from "~/components/v3/events-components/EventImage";
import { EventListItem } from "~/types/EventTypes";
import { getFormattedTimeStamp } from "~/utils/time";
import React from "react";

export const EventItem = ({ event }: { event: EventListItem }) => {
    return (
        <React.Fragment>
            <div className="group flex w-full gap-[1px]" key={event.id}>
                <div
                    className={cn(
                        "ml-[10px] w-[5px] flex-grow-0",
                        "border-l border-v3-N-450 transition-all group-hover:border-v3-N-400",
                    )}
                />
                <div className="flex w-full flex-col">
                    <Link
                        href={`/events/${event.slug}`}
                        target="_blank"
                        className="relative flex h-max flex-col break-all rounded-[4px] py-3 pl-2 text-start hover:bg-v3-N-400"
                    >
                        <div className="z-10 flex flex-row items-start">
                            {event.image && (
                                <div className="relative h-[72px] w-[128px] rounded-[4px]">
                                    <EventImage
                                        event={event}
                                        options={{
                                            type: "contain",
                                        }}
                                        className="aspect-video rounded-xl"
                                        isReadonly
                                    />
                                </div>
                            )}
                            <div className="mx-2 flex min-w-[100px] flex-col">
                                <div
                                    className="line-clamp-2 w-fit min-w-0 max-w-inherit overflow-hidden"
                                    style={{
                                        wordBreak: "break-word",
                                    }}
                                >
                                    {event.name}
                                </div>

                                <div className="flex items-center gap-1 text-v3-N-300">
                                    <RiCalendarEventLine className="mt-1 h-3 w-3 flex-shrink-0 self-start" />
                                    <span className="text-sm">
                                        {event?.isTimeSet
                                            ? getFormattedTimeStamp(
                                                  event.startTime,
                                              )
                                            : "TBD"}
                                    </span>
                                </div>

                                <If condition={!!event.city}>
                                    <div className="flex items-center gap-1 text-v3-N-300">
                                        <MdOutlineLocationOn className="h-3 w-3 flex-shrink-0" />
                                        <span className="text-sm">
                                            {event.city}
                                        </span>
                                    </div>
                                </If>

                                <If condition={!!event.virtualEventUrl}>
                                    <div className="flex items-center gap-1 text-v3-N-300">
                                        <RiVideoLine className="h-3 w-3 flex-shrink-0" />
                                        <span className="text-sm">
                                            Virtual Event
                                        </span>
                                    </div>
                                </If>

                                <div
                                    style={{
                                        wordBreak: "break-word",
                                    }}
                                    className={cn(
                                        "flex flex-wrap items-center",
                                        "text-sm",
                                        !event.hosts.length && "hidden",
                                    )}
                                >
                                    <div className="flex items-center gap-1 text-v3-N-300">
                                        <RiUserLine className="h-3 w-3 flex-shrink-0" />
                                        <span className="mr-1 text-sm">
                                            Hosted by:
                                        </span>
                                    </div>
                                    {event.hosts.map((h, index) => (
                                        <Fragment key={h.user.id}>
                                            {h.user.organizationName ? (
                                                <Link
                                                    className="text-v3-primary hover:underline"
                                                    href={`?organization=${h.user.organizationName}`}
                                                    scroll={false}
                                                >
                                                    {h.user.organizationName}
                                                </Link>
                                            ) : (
                                                <span>{h.user.name}</span>
                                            )}
                                            {index < event.hosts.length - 1 && (
                                                <span>,&nbsp;</span>
                                            )}
                                        </Fragment>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </Link>
                </div>
            </div>
        </React.Fragment>
    );
};
